<template>
  <div class="template">
    <q-form class="q-px-xl" ref="loginForm" @submit.prevent.stop="onSubmit">
      <div class="group-input col-12 row q-mt-sm">
        <label for="os_number">Nome Completo</label>
        <q-input
          id="os_number"
          ref="osNumberRef"
          type="text"
          class="col-12 q-mt-sm"
          bg-color="white"
          maxlength="40"
          color="red-9"
          dense
          outlined
          unmasked-value
          v-model="auth.name"
          :rules="[(val) => !!val.length || 'Campo Obrigatório']"
          lazy-rules
        />
      </div>

      <div class="group-input col-12 row q-mt-sm">
        <label for="os_number">Usuário</label>
        <q-input
          id="os_number"
          ref="osNumberRef"
          type="text"
          class="col-12 q-mt-sm"
          bg-color="white"
          maxlength="30"
          color="red-9"
          dense
          outlined
          unmasked-value
          v-model="auth.username"
          :rules="[(val) => !!val.length || 'Campo Obrigatório']"
          lazy-rules
        />
      </div>

      <div class="group-input col-12 row q-mt-sm">
        <q-checkbox v-model="auth.isAdm" color="red-9" keep-color>
          <label>Pode habilitar contigênica?</label>
        </q-checkbox>
      </div>

      <div class="submit-btn col-12 row q-mt-sm">
        <div class="submit-btn col-md-12 flex justify-end section-btn">
          <q-btn
            class="submit-btn"
            unelevated
            no-caps
            :loading="btnLoading"
            size="md"
            type="submit"
            label="Cadastro"
            rounded
            color="red-9"
          />
        </div>
      </div>
    </q-form>
  </div>
</template>

<script>
//-----VUEJS
import { ref } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

//-----QUASAR
import { useQuasar } from "quasar";
//-----SERVICES
import ContingencyServices from "@/services/ContingencyServices";

export default {
  name: "RegisterUser",

  setup() {
    //----CONSTANTS
    const loginForm = ref(null);
    const $q = useQuasar();
    const router = useRouter();

    //----VARIABLES
    let auth = ref({
      username: "",
      name: "",
      isAdm: false,
    });
    let btnLoading = ref(false);
    let isPwd = ref(true);
    let contingencyServices = new ContingencyServices();

    async function onSubmit() {
      if (!(await loginForm.value.validate())) {
        $q.notify({
          color: "red-5",
          message: "Você precisa preencher todos os campos obrigatórios",
        });
        return;
      }
      btnLoading.value = true;

      let data = {
        nome: auth.value.name,
        usuario: auth.value.username,
        habilitar_Contingencia: auth.value.isAdm,
      };

      btnLoading.value = false;

      //FUNCTIONS
      await contingencyServices
        .registerUserByAdm(data)
        .then((response) => {
          $q.notify({
            message: "O usuário cadastrado com sucesso.",
            color: "green-9",
            position: "top",
          });
          router.push({ name: "config" });
        })
        .catch((error) => {
          btnLoading.value = false;
          $q.notify({
            message: error.response.data.toString(),
            color: "red-9",
            position: "top",
          });
        });
    }

    return {
      //----VARIABLES
      loginForm,
      auth,
      btnLoading,
      isPwd,

      //FUNCTIONS
      onSubmit,
    };
  },
};
</script>
<style lang="scss" scoped>
.template {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #e5e5e5;

  label {
    color: rgba(0, 0, 0, 0.4);
    font-size: 0.875rem;
    font-family: Roboto;
    font-weight: 700;
  }
}

.submit-btn {
  width: 100%;
  display: flex;
}
</style>
